import React from 'react';

const BusinessReplyCard = ({ onClick, className = '' }) => {
    return (
        <button
            onClick={onClick}
            className={`group w-full bg-[#fdfbf7] p-4 rounded-sm shadow-sm border border-[#e5e5e5] hover:shadow-md hover:border-[#d4d4d4] transition-all relative overflow-hidden text-left ${className}`}
        >
            {/* Paper Texture Overlay */}
            <div className="absolute inset-0 opacity-[0.03] pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/cream-paper.png')]"></div>

            {/* Top Bar / FIM Marks (Vertical Lines at Top Center) */}
            <div className="flex justify-center mb-4 space-x-1 opacity-80">
                <div className="w-[2px] h-8 bg-black/80"></div>
                <div className="w-[2px] h-8 bg-black/80"></div>
                <div className="w-[2px] h-8 bg-black/80"></div>
                <div className="w-[2px] h-8 bg-black/80"></div>
                <div className="w-[6px] h-8"></div> {/* Spacer */}
                <div className="w-[2px] h-8 bg-black/80"></div>
            </div>

            <div className="flex justify-between items-start relative z-10">
                {/* Left Side: Business Reply Header */}
                <div className="flex-1 pr-4">
                    <div className="border-b-[3px] border-black/80 pb-1 mb-1">
                        <h3 className="font-sans font-black text-sm uppercase tracking-tighter leading-none text-black transform scale-y-110">
                            Business Reply Mail
                        </h3>
                    </div>
                    <div className="border-b-[1px] border-black/80 pb-1 mb-3">
                        <div className="text-[6px] font-mono text-black uppercase tracking-tight font-bold">
                            First Class Permit No. 100 Flagler Beach, FL
                        </div>
                    </div>
                    <div className="text-[6px] font-mono text-black uppercase tracking-tight mb-4">
                        Postage will be paid by addressee
                    </div>

                    {/* Logo / Addressee */}
                    <div className="mb-2">
                        <h2 className="font-sans font-black text-xl tracking-tighter text-black leading-none mb-1 transform -translate-x-0.5">
                            Welcome to Paradise.
                        </h2>
                        <div className="text-[9px] font-mono text-black uppercase leading-tight">
                            P.O. Box 420525<br />
                            Palm Coast, FL 32142-9252
                        </div>
                    </div>
                </div>

                {/* Right Side: Postage Area & Bars */}
                <div className="flex flex-col items-end">
                    {/* Postage Box */}
                    <div className="border border-black/80 p-1 mb-2 w-16 text-center">
                        <div className="text-[5px] font-bold font-sans uppercase leading-tight text-black">
                            No Postage<br />Necessary<br />If Mailed<br />In The<br />United States
                        </div>
                    </div>

                    {/* Horizontal Bars (Facing Identification Mark - approximate) */}
                    <div className="flex flex-col items-end space-y-[2px] w-8">
                        {[...Array(9)].map((_, i) => (
                            <div key={i} className="w-full h-[3px] bg-black/80"></div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Bottom: Barcode representation */}
            <div className="mt-4 flex items-end h-6 space-x-[2px] opacity-80 justify-center">
                {[...Array(40)].map((_, i) => (
                    <div
                        key={i}
                        className={`bg-black/80 w-[1px] ${i % 3 === 0 ? 'h-full' : i % 2 === 0 ? 'h-4' : 'h-3'}`}
                    ></div>
                ))}
            </div>

            {/* Hover 'Click to Write' Indication */}
            <div className="absolute inset-0 bg-[#d4af37]/5 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center pointer-events-none">
                <div className="bg-white/90 px-3 py-1 rounded border border-[#d4af37] text-[#8a7030] text-[9px] font-bold uppercase tracking-widest shadow-sm">
                    Open Request Form
                </div>
            </div>
        </button>
    );
};

export default BusinessReplyCard;
